import 'reflect-metadata';
import React, { FC } from 'react';
import './styles/site.css';
import './styles/react-date-picker.css';
import { observer } from 'mobx-react-lite';
import { ThemeProviderProps, ThemeProvider as _ThemeProvider } from '@trackman/web-shared-components';
import { Provider } from './services/ioc/ioc.react';
import ErrorBoundary from './components/error/ErrorBundary';
import Layout from './Layout';
import { container } from './services/ioc/ioc';

const ThemeProvider = _ThemeProvider as unknown as FC<ThemeProviderProps & { children?: React.ReactNode }>;

const App: React.FC = observer(() => {
  return (
    <ThemeProvider>
      <Provider container={container}>
        <ErrorBoundary>
          <Layout />
        </ErrorBoundary>
      </Provider>
    </ThemeProvider>
  );
});

export default App;
